module.exports = __webpack_public_path__ + "static/trabajando_01-5f5528594a27a820e660a330f6ce6452.jpg";